import { useCallback, useEffect, useRef, useState } from 'react';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { authService } from '../services';

function useQuickSightEmbed (dashboardName) {
    const [embedUrl, setEmbedUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const containerRef = useRef(null);

    const load = useCallback((isMounted = () => true) => {
        setLoading(true);
        setError(null);
        setEmbedUrl(null);

        authService
            .getQuickSightEmbedUrl(dashboardName)
            .then(res => {
                if (!isMounted()) {
                    return;
                }

                if (!res || !res.embedUrl) {
                    setError(true);
                    setLoading(false);
                    return;
                }

                setEmbedUrl(res.embedUrl);
                setLoading(false);
            })
            .catch(() => {
                if (isMounted()) {
                    setError(true);
                    setLoading(false);
                }
            });
    }, [dashboardName]);

    useEffect(() => {
        let mounted = true;

        load(() => mounted);

        return () => {
            mounted = false;
        };
    }, [load]);

    useEffect(() => {
        if (loading || !embedUrl || !containerRef.current) return;

        let cancelled = false;

        createEmbeddingContext()
            .then(context => {
                if (cancelled || !containerRef.current) return;
                context.embedDashboard(
                    {
                        url: embedUrl,
                        container: containerRef.current,
                        height: '38.462rem',
                        width: '100%',
                        resizeHeightOnSizeChangedEvent: true,
                    }
                );
            })
            .catch(() => {
                if (!cancelled) setError(true);
            });

        return () => { cancelled = true; };
    }, [loading, embedUrl]);

    return { loading, error, containerRef, retry: () => load() };
}

export default useQuickSightEmbed;
